/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { searchFormStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchForm";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

searchFormStyles.wrapper = {
    css: css`
        > div {
            div[class^="GridWrapper"] {
                padding: 0;
            }
            padding: 15px;
            background: ${getColor("common.background")};
            border: 1px solid ${getColor("common.ui12")};
            margin-top: -11px;
        }
    `,
};

searchFormStyles.headingText = {
    css: css`
        display: none;
    `,
};
